<template>
  <div
    class="mx-10 my-5 bg-transparent px-10 py-5 rounded-2xl flex flex-wrap gap-x-10 gap-y-5 justify-between items-center text-white"
  >
    <router-link to="/privacity">
      <img src="@/assets/images/logo.png" alt="" class="w-[50px] h-[52px]" />
    </router-link>
    <div
      class="w-fit flex flex-wrap justify-around xl:justify-end items-center gap-x-10 gap-y-5"
    >
      <router-link to="/privacity">POLITICAS DE PRIVACIDAD</router-link>
      <router-link to="/about">ACERCA DE LA APP</router-link>
      <router-link to="/terms">TERMINOS Y CONDICIONES</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavbarComponent',
};
</script>

<style></style>
